class TeamsService {
  constructor(apiService) {
    this.apiService = apiService;
  }

  getTeams(params) {
    return this.apiService.get('/api/v1/avg/teams', params);
  }

  getTeamByID(id) {
    return this.apiService.get(`/api/v1/avg/teams/${id}`);
  }

  createTeam(params) {
    return this.apiService.post('/api/v1/avg/teams', params);
  }

  updateTeam(id, params) {
    return this.apiService.put(`/api/v1/avg/teams/${id}`, params);
  }

  deleteTeams(params) {
    return this.apiService.delete('/api/v1/avg/teams', params);
  }

  getUsersLookup() {
    return this.apiService.get('/api/v1/users');
  }
}

export default TeamsService;
